import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addStepFailure,
  addStepSuccess,
  deleteStepFailure,
  //
  deleteStepSuccess,
  editStepFailure,
  //
  editStepSuccess,
  fetchStepsFailure,
  fetchStepsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  toggleStepAdd,
  updateStepOrderFailure,
  updateStepOrderSuccess,
  validateDeleteFailure,
  validateDeleteSuccess,
} from "./actions";
import {
  ADD_STEP,
  DELETE_STEP,
  EDIT_STEP,
  FETCH_STEPS,
  GET_VIEW_DATA,
  UPDATE_STEP_ORDER,
  VALIDATE_DELETE,
} from "./constants";

export function* fetchStepsSaga({ payload, onFetch }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.filters ? QueryString.stringify(payload?.filters) : "";
  try {
    const { data } = yield call(api(token).get, `/api/form-step?${query}`);
    yield put(fetchStepsSuccess(data));
    typeof onFetch === "function" && onFetch(data?.steps);
  } catch (e) {
    yield put(fetchStepsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching template list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/form-step/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching template data!"));
  }
}

export function* addStepSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/form-step/add`, payload);
    if (data) {
      yield put(successAlert("Step created successfully!"));
      yield put(addStepSuccess());
      yield put(toggleStepAdd({ open: false }));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(addStepFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editStepSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/form-step/edit/${payload.id}`,
      payload,
    );
    if (data) {
      yield put(successAlert("Step updated successfully!"));
      yield put(editStepSuccess());
      yield put(toggleStepAdd({ open: false }));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(editStepFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteStepSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, params } = payload;
  const query = QueryString.stringify(params);
  try {
    const data = yield call(api(token).delete, `/api/form-step/${id}?${query}`);
    if (data) {
      yield put(successAlert("Step deleted successfully!"));
      yield put(deleteStepSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteStepFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateStepOrderSaga({ payload, onStepUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/form-step-sequence`,
      payload,
    );
    if (data) {
      yield put(successAlert("Step order updated successfully!"));
      yield put(updateStepOrderSuccess());
      typeof onStepUpdate === "function" && onStepUpdate();
    }
  } catch (e) {
    yield put(updateStepOrderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* validateDeleteSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { type, id } = payload;
  const apiConfig = {
    step: `/api/form-step/${id}/check-before-delete`,
    field: `/api/form-field/${id}/check-before-delete`,
  };
  try {
    const { data } = yield call(api(token).get, apiConfig[type]);
    if (data) {
      yield put(validateDeleteSuccess());
      typeof callback === "function" && callback(data?.length <= 0);
    }
  } catch (e) {
    yield put(validateDeleteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchStepsFlow() {
  yield takeEvery(FETCH_STEPS, fetchStepsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addStepFlow() {
  yield takeEvery(ADD_STEP, addStepSaga);
}
export function* editStepFlow() {
  yield takeEvery(EDIT_STEP, editStepSaga);
}
export function* deleteStepFlow() {
  yield takeEvery(DELETE_STEP, deleteStepSaga);
}
export function* updateStepOrderflow() {
  yield takeEvery(UPDATE_STEP_ORDER, updateStepOrderSaga);
}
export function* validateDeleteFlow() {
  yield takeEvery(VALIDATE_DELETE, validateDeleteSaga);
}

export default function* StepSaga() {
  yield all([
    fetchStepsFlow(),
    addStepFlow(),
    editStepFlow(),
    deleteStepFlow(),
    getViewDataFlow(),
    updateStepOrderflow(),
    validateDeleteFlow(),
  ]);
}
